import SameAs from '@core/Areas/RaceCard/Components/RaceCardContent/Components/LegacyKnockout/ViewModels/Betting-v2/Model/SameAs'
import Guard from '../../../../AppUtils/Framework/Guard'
import type { BettingInformation } from '../../../Model/BettingInformation'
import type { IObservableStarter } from '../../../Model/Observables/IObservableStarter'
import { CheckBoxSelection } from '../UIElements/CheckboxSelection'
import {
  cascadeSameAsDeselectedThroughColumns,
  cascadeSameAsSelectedThroughColumns,
  notifyDependentColumnOfSelection,
  sameAsColumnsDependendentOn,
  updateColumnMatchingSameAs,
} from './SameAsAlgorithms'

export default class CheckBoxSameAsProcessor {
  public process(
    starters: ko.ObservableArray<IObservableStarter>,
    selections: ko.ObservableArray<IObservableStarter>,
    bettingContext: BettingInformation,
    row: number,
    column: number,
    selected: boolean
  ) {
    Guard.notNull(bettingContext)
    Guard.notNull(selections)
    Guard.notNull(starters)
    Guard.greaterThanOrEqualZero(row)
    Guard.greaterThanOrEqualZero(column)

    const sameAsNode = bettingContext.sameAsAt(row, column) as SameAs

    if (selected) {
      notifyDependentColumnOfSelection(starters(), row, column)
      const dependencies = sameAsColumnsDependendentOn(bettingContext, sameAsNode)
      cascadeSameAsSelectedThroughColumns(bettingContext, starters(), dependencies)
      sameAsNode.enable()
    } else {
      const affected = updateColumnMatchingSameAs(bettingContext, starters(), sameAsNode)
      const dependencies = sameAsColumnsDependendentOn(bettingContext, sameAsNode)
      cascadeSameAsDeselectedThroughColumns(bettingContext, affected, dependencies)
      sameAsNode.disable()
    }

    selections(
      starters().filter(starter => (starter.selection() as CheckBoxSelection).anySelected())
    )

    bettingContext.turnOffFieldAt(column - 1)
  }
}
